import React, { useContext, useEffect, useState } from "react";

import AnimatedDiv from "../Menubar/AnimatedDiv";
import TopSearchBarContent from "./TopSearchBarContent";
import useWindowSize from "../windowDimension";
import { StoreContext } from "../../context/context";

const TopSearchBar = ({ setParam, RoutingTypeId, PageId }) => {
  const { backdrop, setBackdrop, mobileBar, setMobileBar } =
    useContext(StoreContext);

  const { width } = useWindowSize();

  useEffect(() => {
    setBackdrop(mobileBar);
  }, [mobileBar]);

  useEffect(() => {
    if (backdrop == false) CloseAll();
  }, [backdrop]);

  const CloseAll = () => {
    setMobileBar(false);
  };

  if (width >= 1024) {
    return (
      <TopSearchBarContent
        setParam={setParam}
        isMobile={false}
        RoutingTypeId={RoutingTypeId}
        PageId={PageId}
      />
    );
  }
  return (
    <>
      {/* Top Search Bar */}
      {mobileBar == "ProductSearch" && (
        <AnimatedDiv onClose={CloseAll}>
          {/* <div className="w-full p-3" onClick={CloseAll}>
            <div className="h-1.5 w-12 bg-black bg-opacity-40 rounded-lg mx-auto"></div>
          </div> */}
          <TopSearchBarContent
            setParam={setParam}
            isMobile={true}
            RoutingTypeId={RoutingTypeId}
            onClick={CloseAll}
            PageId={PageId}
          />
        </AnimatedDiv>
      )}
      {/* Top Search Bar */}
    </>
  );
};

export default TopSearchBar;
